import SingleProductTagSelector from './SingleProductTagSelector';

export type { OnChangeParams as SingleTagSelectorOnChangeParams } from '@features/product-tags/mutations';

export default SingleProductTagSelector;
